import { getCouncilTrackerUrl, councilLinkLabel } from '../lib/councilLinks';
import CouncilSearchHelp from './ui/CouncilSearchHelp';
import { applicationSourceReturnHref, sourceBackHref } from '../lib/sourceReturn';

export default function SourceDocumentPausedPage() {
  const params = new URLSearchParams(window.location.search);
  const rawReference = params.get('da_number') || '';
  const app = { da_number: /^[A-Za-z0-9./-]{1,40}$/.test(rawReference) ? rawReference : null };
  const councilUrl = getCouncilTrackerUrl({ ...app, source_url: params.get('referer') })
    || getCouncilTrackerUrl({ ...app, source_url: params.get('url') });
  const returnHref = applicationSourceReturnHref(params.get('da_id')) || sourceBackHref();
  return <main style={{ minHeight: '100vh', background: '#071423', color: '#e8e0d8', padding: 24, fontFamily: 'sans-serif' }}>
    <section style={{ maxWidth: 520, margin: '48px auto' }}>
      <h1>Document viewing is paused</h1>
      <p>You can return to your application{councilUrl ? ' or visit the council website' : ''}.</p>
      <a href={returnHref} style={{ display: 'inline-flex', alignItems: 'center', minHeight: 44, color: '#d4a84a', marginRight: 20 }}>Back to application</a>
      {councilUrl && <a href={councilUrl} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', minHeight: 44, color: '#d4a84a' }}>{councilLinkLabel(councilUrl)}</a>}
      <CouncilSearchHelp app={app} url={councilUrl} color="#e8e0d8" accent="#d4a84a" />
    </section>
  </main>;
}
